/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Invitation_Rate_ColumnInputs */

const en_admin_statistics_invitation_rate_column = /** @type {(inputs: Admin_Statistics_Invitation_Rate_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitation rate`)
};

const de_admin_statistics_invitation_rate_column = /** @type {(inputs: Admin_Statistics_Invitation_Rate_ColumnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungsquote`)
};

/**
* | output |
* | --- |
* | "Invitation rate" |
*
* @param {Admin_Statistics_Invitation_Rate_ColumnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_invitation_rate_column = /** @type {((inputs?: Admin_Statistics_Invitation_Rate_ColumnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Invitation_Rate_ColumnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_invitation_rate_column(inputs)
	return en_admin_statistics_invitation_rate_column(inputs)
});